import { defineStore } from 'pinia'

const useRequestLocationStore = defineStore('requestLocation', {
  state: () => ({
    countryCode: '',
  }),
})

export default useRequestLocationStore
